"use client";

import { METRICS_EVENTS } from "@cede/types";
import { Button } from "@/components/ui/button";
import { useTelegramContext } from "@/contexts/TelegramContext";
import { useMetricsEvents, useTrackEvent } from "@/hooks/data/useMetricsEvents";
import Image from "next/image";
import { useSnackbar } from "notistack";

const SUCCESS_MESSAGE = "Thanks for reaching out. We will keep you posted.";

export const TmaUnavailablePage = () => {
  const { isTMA } = useTelegramContext();
  const { enqueueSnackbar } = useSnackbar();
  const { trackEvent } = useMetricsEvents();

  useTrackEvent({ event: METRICS_EVENTS.TMA_UNAVAILABLE_VIEWED, enabled: isTMA });

  if (!isTMA) return null;

  const handleKeepInTouch = () => {
    trackEvent(METRICS_EVENTS.TMA_UNAVAILABLE_KEEP_IN_TOUCH_CLICKED, {});
    enqueueSnackbar(SUCCESS_MESSAGE, { variant: "success" });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-mobile-background)] px-6 py-10">
      <div className="flex w-full max-w-[520px] flex-col items-center gap-6 text-center">
        <Image src="/favicon.ico" alt="Cede Hub" width={96} height={96} unoptimized />
        <h2 className="h2 text-cede-text-primary">Cede Bot is temporarily unavailable</h2>
        <p className="body1 text-cede-text-secondary">
          The mini app is paused right now. We will be back soon with the updates.
        </p>
        <Button size="large" variant="primary" onClick={handleKeepInTouch} className="w-full max-w-[320px]">
          Keep me in touch
        </Button>
      </div>
    </div>
  );
};
